import { render, staticRenderFns } from "./scope.vue?vue&type=template&id=10ed7bec"
import script from "./scope.vue?vue&type=script&lang=js"
export * from "./scope.vue?vue&type=script&lang=js"
import style0 from "./scope.vue?vue&type=style&index=0&id=10ed7bec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports